import {
	CHANGE_DEVICE,
	CHANGE_LANGUAGE,
	SITE_INIT,
} from '../actions/environment';
import { setCookie } from '../utils/dom';

export const initialState = {
	properties: {
		siteInitiated: false,
		siteUpdated: false,
	},
	setup: {},
	searchInputText: '',
	hashLocation: '',
	index: [],
	cart: {},
	indexSort: 'chronological',
	navigation: {
		open: false,
	},
	pagination: {},
};

const environment = (state = initialState, action) => {
	switch (action.type) {
		case CHANGE_DEVICE:
			return {
				...state,
				setup: {
					...state.setup,
					breakPoint: action.device,
				},
			};

		case 'SITE_UPDATED':
			return {
				...state,
				properties: {
					...state.properties,
					siteUpdated: true,
				},
			};

		case 'UPDATE_HASH':
			return {
				...state,
				hashLocation: action.hash,
			};

		case 'PAGE_PATHS':
			return {
				...state,
				pageType: action.pageType,
				pagePaths: action.paths,
			};

		case SITE_INIT:
			return {
				...state,
				properties: {
					...state.properties,
					siteInitiated: true,
				},
			};

		case 'UPDATE_COUNTRY': {
			setCookie('settings', [state.setup.language, action.country, parseInt(action.market, 10), parseInt(action.pricelist, 10)]);
			const shippable = state.setup.countries[action.country].shipTo;
			return {
				...state,
				setup: {
					...state.setup,
					country: action.country,
					market: action.market,
					pricelist: action.pricelist,
					unableToSendToCountry: !shippable,
				},
			};
		}

		case CHANGE_LANGUAGE: {
			setCookie('settings', [action.language, state.setup.country, parseInt(state.setup.market, 10), parseInt(state.setup.pricelist, 10)]);
			return {
				...state,
				setup: {
					...state.setup,
					language: action.language,
				},
			};
		}

		default:
			return state;
	}
};

export default environment;
